import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-sand border-y border-warmgray" data-id="element-132" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-133" data-mp="223y4x6bhk5jl">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-paper border border-terracotta/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-134" data-mp="222n2b9ts13u2">
          <div className="absolute top-0 left-0 w-full h-1 bg-terracotta" data-id="element-135" data-mp="1ed25po4pa82b"></div>

          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-sand text-terracotta mb-8" data-id="element-136" data-mp="qnhmd44mx8si">
            <ShieldCheck size={48} aria-hidden="true" data-id="element-137" data-mp="lodf4j19tl4t" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-charcoal" data-id="element-138" data-mp="p01iaak777bb">
            Complete 7-Day Guarantee
          </h2>

          <div className="space-y-6 text-lg text-charcoal-soft max-w-2xl mx-auto" data-id="element-139" data-mp="tx1k29a0lnwm">
            <p data-id="element-140" data-mp="yqmb1hd6xhmb">
              Open the complete library. Explore the 5 bonuses. Use the
              materials in your most demanding class this week.
            </p>
            <p className="font-medium text-charcoal" data-id="element-141" data-mp="61716ux9hurz">
              If you find the materials aren't clear, practical, or useful for
              your teaching needs, contact us within 7 days.
            </p>
            <p className="text-terracotta-deep font-bold text-xl" data-id="element-142" data-mp="f12gnbxuobxt">
              We'll refund 100% of your money. No questions. No forms. No
              complications.
            </p>
            <p className="text-sm text-charcoal-muted mt-8" data-id="element-143" data-mp="1qh0l12i329sp">
              Because if the material doesn't deliver the value we promised, we
              don't want to keep your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}